import { Box } from "@mui/material"

export const Fullscreen = ({ color, width = 24, height = 24 }) => {
    return (
        <Box
            component="svg"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 33.839 33.839"
            sx={{
                color: color || "#a18168",
            }}
            className="transition-colors"
        >
            <polyline
                points="32.964 10.157 32.964 .125 22.931 .125"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
                fill= "none"
            />
            <polyline
                points="10.157 .125 .125 .125 .125 10.157"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
                fill= "none"
            />
            <polyline
                points="22.931 32.964 32.964 32.964 32.964 22.931"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
                fill= "none"
            />
            <polyline
                points=".125 22.931 .125 32.964 10.157 32.964"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
                fill= "none"
            />
        </Box>
    )
}